import React from "react";

export default function Addbanner1({ banners }) {
  const BaseUrl = process.env.REACT_APP_BASE_URL || "";
  if (!banners?.banner4) return null;

  return (
    <section className="mt-5 pt-5 font-archivo">
      <div className="container-fluid p-0 position-relative">
        <img
          src={`${BaseUrl}/${banners.banner4}`}
          className="img-fluid w-100 sanjiva-masal-banner"
          alt="Sanjeevika Banner"
          loading="lazy"
          decoding="async"
        />
      </div>
    </section>
  );
}
